import { forwardRef, HTMLAttributes } from "preact/compat"
import { Plus } from "lucide-react"
import { classes } from "@/utils"

const VARIANT_CLASSES = {
  /** Table cells on light backgrounds (e.g. the check detail Coding column). */
  light:
    "gap-1 px-2.5 py-0.5 text-xs border-gray-300 text-gray-500 hover:border-gray-500 hover:text-gray-700 hover:bg-gray-50",
  /** The dark slate bulk selection bars. */
  dark: "gap-1.5 px-3 py-2 text-sm border-sky-300/60 text-sky-300 hover:border-sky-300 hover:bg-sky-500/10",
}

interface CodePillProps extends HTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof VARIANT_CLASSES
}

/**
 * Dashed "+ Code" pill indicating an action to assign GL coding.
 * Forwards its ref so it can be used as a Radix `PopoverTrigger asChild` child.
 */
export const CodePill = forwardRef<HTMLButtonElement, CodePillProps>(function CodePill(
  { variant = "light", className, children, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type="button"
      class={classes(
        "inline-flex items-center rounded-full border border-dashed cursor-pointer",
        VARIANT_CLASSES[variant],
        className as string | undefined
      )}
      {...props}
    >
      <Plus className={variant === "light" ? "h-3 w-3" : "h-4 w-4"} />
      {children ?? "Code"}
    </button>
  )
})
